import classNames from "classnames";
import { MouseEventHandler } from "react";

import "./SlideImage.css";

import Spinner from "components/Spinner";

type SlideImageProps = {
  imgSrc: string | undefined;
  altText: string;
  isError?: boolean;
  errText?: string;
  isFullSize?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
};

const SlideImage = ({
  imgSrc,
  altText,
  isError,
  errText,
  isFullSize,
  onClick,
}: SlideImageProps) => {
  return (
    <div
      className={classNames("SlideImg__container", {
        "SlideImg__container--small": !isFullSize || !imgSrc || isError,
      })}
    >
      {!imgSrc && !isError ? (
        <Spinner />
      ) : isError ? (
        errText || "Missing Image"
      ) : (
        <img src={imgSrc} alt={altText} onClick={onClick} />
      )}
    </div>
  );
};

export default SlideImage;
